import notification from "common/utils/notification"
import { toAlphaNumerics } from "common/utils/utils"

export const mapCurrentUser = (data: $TSMigrationFixMe) => ({
  ...data,
  firstName: data.nombre,
  lastName: data.apellidos,

  empresaActiva: {
    ...data.empresaActiva,
    cif: toAlphaNumerics(data.empresaActiva?.cif),
    direccion: data.empresaActiva ? data.empresaActiva?.direccion?.calle : null,
    cp: data.empresaActiva ? data.empresaActiva.direccion?.codigoPostal : null,
    poblacionId: data.empresaActiva
      ? data.empresaActiva.direccion?.poblacionId
      : null,
    poblacion: data.empresaActiva
      ? data.empresaActiva.direccion?.poblacionNombre
      : null,
    provincia: data.empresaActiva
      ? data.empresaActiva.direccion?.provinciaNombre
      : null,
    poblacionExtranjera: data.empresaActiva
      ? data.empresaActiva.direccion?.poblacionExtranjera
      : null,
  },
})

export function capitalize(string: $TSMigrationFixMe) {
  return string?.[0].toUpperCase() + string?.slice(1)
}

export const rangeArrayFromNumber = (
  start: $TSMigrationFixMe,
  stop: $TSMigrationFixMe,
  step: $TSMigrationFixMe
) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)

export const generateFirmasArray = (etapa: $TSMigrationFixMe) => {
  if (etapa?.firmantes?.length) {
    const firmantesArray = rangeArrayFromNumber(
      2,
      etapa?.numeroFirmas - etapa?.firmantes?.length || 0,
      1
    ).fill(etapa.numeroFirmas)

    return [...(etapa?.firmantes || []), ...firmantesArray]
  }
  return rangeArrayFromNumber(2, etapa?.numeroFirmas, 1).fill(
    etapa.numeroFirmas
  )
}

export const checkIfNumberIsPositive = (number: $TSMigrationFixMe) =>
  Math.sign(number) > 0

export const checkDocumentFormat = (
  condition: $TSMigrationFixMe,
  data: $TSMigrationFixMe,
  setData: $TSMigrationFixMe
) => {
  if (condition) {
    setData?.(data)
  } else {
    notification.errorServidor({
      body: "El formato del documento no es el esperado",
    })
  }
}
